type Action =
  | {
      action: "login",
      returnPath?: string
    }
  | {
      action: "share",
      url: string
    }

const sendActionToApp = (action: Action) => {
  let handledBy: string[] = []

  // iOS
  const iOSHandler = (window as any).webkit?.messageHandlers?.['Tippspiel']
  if (iOSHandler) {
    const json = JSON.stringify(action)
    iOSHandler.postMessage(json)
    handledBy.push('iOSHandler');
  }

  // Android
  const AndroidHandler = (window as any)['Tippspiel']
  if (AndroidHandler) {
    const json = JSON.stringify(action)
    AndroidHandler.handleMessage(json)
    handledBy.push('androidHandler');
  }
  console.log("sendActionToApp", handledBy.length > 0 ? handledBy : 'NOT HANDLED', action)
}

const webviewActions = {
  login: (redirectAfterLogin?: string) => sendActionToApp({ action: 'login', returnPath: redirectAfterLogin }),
  share: (url: string) => sendActionToApp({ action: 'share', url }),
}

export default webviewActions
